import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Dropdown } from 'semantic-ui-react';
import { debounce } from 'lodash';
import searchGroup from 'redux/actions/organizations/searchGroup';
import { organizationsDropDownOptions } from 'utils/dropdownOptions';
import './index.scss';

const GroupSearch = ({
  name,
  handleChange,
  error,
  disabled,
  form,
  organizationId,
  label,
  showIcon,
}) => {
  const { items = [], loading } = useSelector(
    ({ organizations: { searchGroup } }) => searchGroup,
  );

  const [value, setValue] = useState('');
  const [addedOptions, setAddedOptions] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (organizationId) {
      searchGroup(organizationId, ' ')(dispatch);
    }
  }, [organizationId]);

  const debouncedSearch = useRef(
    debounce((orgName, query) => {
      searchGroup(orgName, query)(dispatch);
    }, 400),
  ).current;

  const handleSearchChange = (e, { searchQuery }) => {
    setValue(searchQuery);
    debouncedSearch(organizationId || form.org_name, searchQuery);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      debouncedSearch.flush();
      searchGroup(organizationId || form.org_name, value)(dispatch);
    }
  };

  const itemOptions = organizationsDropDownOptions(items, true);

  const options = [...itemOptions, ...addedOptions];

  const handleAddition = (e, { name, value }) => {
    setAddedOptions([{ text: value, value }]);
    handleChange(e, { name, value });
  };

  return (
    <div className={showIcon ? 'group-search' : undefined}>
      <Form.Field
        control={Dropdown}
        className="dropdown-withID"
        search
        selection
        allowAdditions
        handleAddition={handleAddition}
        error={error}
        loading={loading}
        onSearchChange={handleSearchChange}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        options={options}
        type="text"
        label={label}
        name={name}
        placeholder="Group"
        disabled={disabled}
        icon={showIcon ? 'search' : 'dropdown'}
      />
    </div>
  );
};

GroupSearch.defaultProps = {
  name: 'group_name',
  disabled: false,
  organizationId: null,
  label: 'Group',
  showIcon: false,
};

GroupSearch.propTypes = {
  handleChange: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  form: PropTypes.instanceOf(Object).isRequired,
  organizationId: PropTypes.number,
  label: PropTypes.string,
  showIcon: PropTypes.bool,
};

export default GroupSearch;
